import { HttpAdapter } from "../main/adapters/HttpAdapter";

export class BucketHttpGateway {
    HttpAdapter = new HttpAdapter();
    constructor() {
        this.baseUrl = `${publicSettings.aws.baseUrls.assistant}/assistant/bucket`;
    }
    async getSignedUrlByKey(key, bucket) {
        if (!key || !bucket) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-signed-url-by-key`,
                {
                    key,
                    bucket
                }
            );
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    }
}
